<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="m7 13.5c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zm12-7h-8v8h-8v-10h-2v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z"
    />
  </svg>
</template>
